// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__329O6","appName":"Logo_appName__2W5QT","span":"Logo_span__wzw5W"};